<script>
  export let modules;
  export let current_step;

  function get_start(module_idx) {
    let prev_steps = modules
      .filter((el, idx) => idx < module_idx)
      .map(el => el.steps ? el.steps.length : 1) // +1 error page
      .reduce((acc, val) => acc = acc + val, 1); // +1 front page

    return prev_steps + module_idx * 3; // *2 module title + aim/remarks + module end
  }

  function in_range(module_idx) {
    return get_start(module_idx) <= current_step &&
      current_step < get_start(module_idx + 1);
  }

  function set_current(module_idx) {
    let step_number = get_start(module_idx);
    return e => current_step = step_number;
  }
</script>

<div class="tabs tabs-boxed bg-base-100 justify-evenly pt-0">
  {#each modules as mod, idx}
      <a class:tab-active="{current_step, in_range(idx)}" class="tab transition lg:-translate-y-6 lg:p-8 bg-base-300 text-white font-bold uppercase" on:click="{set_current(idx)}">
        {mod.name}
      </a> 
  {/each}
</div>

<style>
  .tab {
    display: inline-block;
    width: 20vw;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    border-radius: 0 0 var(--rounded-btn) var(--rounded-btn);
  }

  .tab-active {
    transform: translateY(0);
  }
</style>